//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/SelectBodyList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[0,"DrawVentHoles",1,0],[1,"Extension",0,"Expression",0],[0,"FillingCoefficient",1,0],[1,"GridSpacing",0,"Expression",0],[1,"LowerMargin",0,"Expression",0],[0,"MaxNumberOfCurves",1,0],[0,"Measure",1,0],[0,"Method",1,0],[0,"NeutralAxisPercent",1,0],[0,"NeutralMethod",1,0],[0,"NonlinearityCoefficient",1,0],[0,"NumberOfCurves",1,0],[0,"NumberOfRows",1,0],[0,"OffsetBetweenDiagrams",1,0],[1,"Overlap",0,"Expression",0],[1,"ProfileBodies",0,"SelectBodyList",0],[0,"ReferencePlane",1,0],[0,"ReferencePlanePoint",1,"Point",0],[1,"SideMargin",0,"Expression",0],[1,"UpperMargin",0,"Expression",0],[0,"UserCsys",1,"CoordinateSystem",0],[1,"VarMarginIncrement",0,"Expression",0],[1,"VarMarginMax",0,"Expression",0],[1,"VarMarginMin",0,"Expression",0],[0,"VarOverlapMax",1,0],[0,"VarOverlapMin",1,0]],[[["num_failed","failed_reasons"],"GetFailedProfiles",{R_:{failed_profiles:"Body[]"}},0,0]],[]];
SPLM.Features.ShipDesign.InverseBendingLinesBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.InverseBendingLinesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.InverseBendingLinesBuilder.MethodType = Object.freeze({
    "Automatic" : "Automatic", "NumberOfCurves" : "NumberOfCurves", "FillingCoefficient" : "FillingCoefficient", "EvenFit" : "EvenFit"});

SPLM.Features.ShipDesign.InverseBendingLinesBuilder.NeutralMethodType = Object.freeze({
    "BaseLine" : "BaseLine", "CenterLine" : "CenterLine", "NeutralAxis" : "NeutralAxis"});

SPLM.Features.ShipDesign.InverseBendingLinesBuilder.ReferencePlaneType = Object.freeze({
    "XCYCPlane" : "XCYCPlane", "YCZCPlane" : "YCZCPlane", "ZCXCPlane" : "ZCXCPlane", "NegativeXCYCPlane" : "NegativeXCYCPlane", "NegativeYCZCPlane" : "NegativeYCZCPlane", "NegativeZCXCPlane" : "NegativeZCXCPlane", "DefineCSYS" : "DefineCSYS"});

SPLM.Features.ShipDesign.InverseBendingLinesBuilder.MeasureType = Object.freeze({
    "LeftToRight" : "LeftToRight", "RightToLeft" : "RightToLeft"});

export default SPLM;